import {Truncate} from '@dropbox/dig-components/truncate';
import {Typeahead} from '@dropbox/dig-components/typeahead';
import {Text} from '@dropbox/dig-components/typography';
import {Box} from '@dropbox/dig-foundations';
import {UIIcon} from '@dropbox/dig-icons';
import {LightbulbLine, LinkLine, OpenLine} from '@dropbox/dig-icons/assets';
import {KnowledgeSearchResult} from 'client';
import {t} from 'i18next';

import styles from './PeopleSearch.module.css';
import {ResultIcon} from './ResultIcon';

/** How many Knowledge results "All" shows, after people and teams. */
export const KNOWLEDGE_ALL_LIMIT = 3;

const hostname = (url: string) => {
  try {
    return new URL(url).hostname.replace(/^www\./, '');
  } catch {
    return null;
  }
};

const subtitle = (item: KnowledgeSearchResult) => {
  if (item.kind === KnowledgeSearchResult.kind.LINK) {
    const host = item.external ? hostname(item.url) : null;
    return host ? t('search_knowledge_link_external', {host}) : t('search_knowledge_link');
  }
  return item.excerpt || t('search_knowledge_article');
};

export const KnowledgeResultRow = ({
  item,
  tiled,
}: {
  item: KnowledgeSearchResult & {idx: number};
  tiled: boolean;
}) => (
  <Typeahead.Row
    key={item.id}
    value={{
      route: 'knowledge',
      path: item.id,
      href: item.url,
      index: item.idx,
      label: item.title,
    }}
    withTitle={
      <Box marginY="0">
        <Text isBold>
          <Truncate lines={1} maxWidth={700}>
            {item.title}
          </Truncate>
        </Text>
      </Box>
    }
    withSubtitle={
      <Text size="small" color="faint">
        <Truncate lines={1} maxWidth={700}>
          {subtitle(item)}
        </Truncate>
      </Text>
    }
    withRightAccessory={
      item.external ? (
        <UIIcon src={OpenLine} size="small" aria-label={t('search_knowledge_opens_new_tab')} />
      ) : undefined
    }
    className={styles.typeaheadRow}
    withLeftAccessory={
      <ResultIcon
        src={item.kind === KnowledgeSearchResult.kind.LINK ? LinkLine : LightbulbLine}
        tiled={tiled}
      />
    }
  />
);
